// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__gkm6q","l2":"styles_l2__X3qCf"};